import React, { FC } from 'react';
import { CheckboxGroupItemProps } from 'react-uforms';
import { WithStyle } from '@ch/common/utils';
import { FormCheckboxStyled, FormCheckboxGroupItemInput, FormCheckboxLabel, FormCheckboxIcon } from './checkbox.styled';
import { CheckboxGroupItemStyleProps } from './types';
import { IconCheck } from '@ch/common/components/icon';

export const FormCheckboxGroupItem: FC<CheckboxGroupItemStyleProps & CheckboxGroupItemProps> & WithStyle = ({
  ref: _ref,
  as: _as,
  children,
  $size,
  $variant,
  ...rest
}) => (
  <FormCheckboxStyled>
    <FormCheckboxGroupItemInput {...rest} />
    <FormCheckboxLabel {...{ $size, $variant }}>
      <FormCheckboxIcon>
        <IconCheck $size={14} />
      </FormCheckboxIcon>
      {children}
    </FormCheckboxLabel>
  </FormCheckboxStyled>
);

FormCheckboxGroupItem.defaultProps = {
  $size: 'md',
  $variant: 'default',
  disabled: false,
};
